<ws-modal-wrapper headerLabel="Equalization Factor"
                  [loading]="loading"
                  [hideSave]="true"
                  [excludeModalStyling]="true"
                  cancelLabel="Close"
                  (cancel)="close(true)">
    <div class="d-flex flex-column ws-stretch">
        <div class="ws-section">
            <div class="ws-section__header">
                <div class="ws-section__header__actions__right">
                    @if (canEdit) {
                        <div class="ws-section__header__actions__item">
                            @if (!editMode) {
                                <button
                                    type="button"
                                    class="ace-btn btn-sm btn-primary has-icon"
                                    (click)="goToEditMode()"
                                    title="Edit">
                                    <i class="fa fa-pencil"></i>
                                </button>
                            }
                            @if (editMode) {
                                <button
                                    type="button"
                                    class="ace-btn btn-sm btn-primary has-icon"
                                    (click)="save()"
                                    title="Save"
                                    [disabled]="loading || isInvalid">
                                    <i class="fa fa-save"></i>
                                </button>
                            }
                            @if (editMode && rule) {
                                <button
                                    type="button"
                                    class="ace-btn btn-sm btn-primary btn-danger has-icon"
                                    (click)="delete()"
                                    title="Delete"
                                    [disabled]="loading">
                                    <i class="fa fa-trash"></i>
                                </button>
                            }
                            @if (editMode) {
                                <button
                                    type="button"
                                    class="ace-btn btn-sm btn-primary btn-danger has-icon"
                                    (click)="cancel()"
                                    title="Cancel"
                                    [disabled]="loading">
                                    <i class="fa fa-close"></i>
                                </button>
                            }
                        </div>
                    }
                </div>
            </div>
        </div>
        <div class="card panel-flat-color primary-panel m-0 pb-0">
            <div class="panel-flat-header">
                <h3>Info</h3>
            </div>
            <div class="panel-flat-body">
                <div class="mb-3">
                    <label for="equalization-property-type">Property Type</label>
                    @if (!editMode) {
                        <div>{{ rule?.propertyType }}</div>
                    }
                    @if (editMode) {
                        <select id="equalization-property-type" class="form-select" [(ngModel)]="model.propertyType" [disabled]="!!rule">
                            <option [ngValue]="null" disabled hidden>Select Property Type</option>
                            @for (propertyType of propertyTypes; track propertyType.propertyTypeID) {
                                <option [ngValue]="propertyType.propertyTypeID">{{ propertyType.propTypeName }}</option>
                            }
                        </select>
                    }
                </div>
                <div class="mb-3">
                    <label for="equalization-tax-year">Tax Year</label>
                    @if (!editMode) {
                        <div>{{ rule?.taxYear }}</div>
                    }
                    @if (editMode) {
                        <input id="equalization-tax-year" class="form-control" type="number" min="2001" max="2050"
                               [(ngModel)]="model.taxYear" [disabled]="!!rule">
                    }
                </div>
                <div class="mb-3">
                    <label for="equalization-factor">Eq. Factor</label>
                    @if (!editMode) {
                        <div>{{ model.factor | number: '1.4-4' }}</div>
                    }
                    @if (editMode) {
                        <input id="equalization-factor" class="form-control" type="text" maxlength="7"
                               style="width: 100px; text-align: right;"
                               [(ngModel)]="model.factor"
                               currencyMask
                               [options]="{ allowNegative: false, precision: 4, prefix: '' }">
                    }
                </div>
                <div class="mb-3">
                    <label for="equalization-status">Status</label>
                    @if (!editMode) {
                        <div>{{ rule?.isActual ? 'Actual' : 'Estimate' }}</div>
                    }
                    @if (editMode) {
                        <select id="equalization-status" class="form-select" [(ngModel)]="model.isActual">
                            <option [ngValue]="null" disabled hidden>Select Status</option>
                            <option [ngValue]="true">Actual</option>
                            <option [ngValue]="false">Estimate</option>
                        </select>
                    }
                </div>
                <div class="mb-3">
                    @if (!editMode) {
                        <label for="equalization-automatically-add">Automatically Add</label>
                        <div>{{ rule?.automaticallyAdd ? 'Yes' : 'No' }}</div>
                    }
                    @if (editMode) {
                        <div class="form-check">
                            <input id="equalization-automatically-add" class="form-check-input" type="checkbox"
                                   [(ngModel)]="model.automaticallyAdd">
                            <label class="form-check-label" for="equalization-automatically-add">Automatically Add</label>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</ws-modal-wrapper>
